export function insertHtml(fullText, splitText, html) {
	let result = fullText.split(splitText).flatMap((item) => [item, html]);
	result.pop();
	return result;
}
